import { StorageProvider } from '../interface/storage-provider.interface';

export class LocalStorageService implements StorageProvider {
  set(key: string, value: any): void {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  get(key: string): any {
    const value: string = window.localStorage.getItem(key);
    let storedItem: any;

    try {
      storedItem = JSON.parse(value);
    } catch (error) {
      this.remove(key);
      storedItem = null;
    }

    return storedItem;
  }

  remove(key: string): void {
    window.localStorage.removeItem(key);
  }
}
